<template>
  <div class="bgHomePage md-layout" >
    <!--section2 text top-->
    <section class="md-layout-item positionTopContainer md-size-100 md-layout md-alignment-center">
      <div class="md-layout-item  grid-pad md-layout topContainer" style=" ">
        <!-- left side-->
        <div class="md-layout-item md-size-100  md-layout md-alignment-center">
            <div class="md-layout-item md-layout section2Text">
                <h2 class="md-layout-item md-size-100 f-primary">Carrières</h2>
                <h3 class="md-layout-item md-size-100 f-white" style="padding-top:10px;">Joins-toi à notre équipe</h3>
                <v-row class="md-layout-item md-size-100 md-layout jobList" style="line-height:1px">
                    <v-col class="md-layout-item md-size-25 md-layout" v-for="(item,i) in this.jobs" :key="i">
                        <div class="md-layout-item md-layout jobTitle">
                            <router-link :to="item.path"> <p class="f-white " style="padding:0px 0px 0px 20px;"> {{ item.title }} </p> </router-link>
                        </div>                      
                    </v-col>
                </v-row>
            </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style scoped>
    .f-primary { color: rgb(40, 133, 34) !important; }
    .f-white {  color: white;}
    .bgHomePage { height: 100%; background-image: url('../../../public/resources/images/BannerIndexTop.jpg'); background-position: center center; background-size: cover; background-repeat: no-repeat; }
    h2 { font-weight: 700; }
    .section2Text p { font-size: clamp(0.75em,1.5vw,1.25em); line-height:29.26px; text-align: justify; margin: 25px 0px; font-weight: 100; }
    .positionTopContainer { position:relative; z-index:1; top:50px;  min-height: 800px; height: 100%; }
    .topContainer { min-height: 350px; height:auto; background-color: rgba(10, 10, 10,0.8);border-top: 10px solid rgb(40, 133, 34); border-bottom: 10px solid rgb(40, 133, 34); }
    .error { color: red !important; }
    .section2Text p:hover { color: rgb(40, 133, 34) !important; }
    .section2Text a { text-decoration: none !important;}

    @media handheld, only screen and (max-width: 600px) {
        .gridpadForm {padding: 50px 10px;}
    }
    @media handheld, only screen and (max-width: 960px) {
        .positionTopContainer { top:50px; }
        .Caroussel { height: unset; margin: 20px auto !important; overflow: hidden; }
        .BGTextCarousselContainer { margin: auto;}
        .imgContainer { margin: auto; }
        .topContainer { max-height: unset; }
    }
    @media handheld, only screen and (max-width: 1279px) {}
    @media handheld, only screen and (max-width: 1378px) {}
</style>
<script>
    import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'Home',
    data: () => ({
        drawer: false,
        jobs:null,
    }),
    async mounted() {
        await this.jobsJsonRead();
    },
    methods: {
    jobsJsonRead: async function () {
        try {
            const response = await fetch('/resources/json/jobs.json');
            if (!response.ok) { throw new Error('Failed to fetch'); }
            this.jobs = await response.json();

        } catch (error) {
            console.error('Error loading JSON data:', error);
        }
    },
        
    },
    components: { },
}
</script>